export default __webpack_public_path__ + "static/media/extendbi.favicon.ffcc75eb.ico";